module.exports = ".loading-content{\n    height: 100%;\n    position: fixed;\n    width: 100%;\n    background: white;\n    top: 0;\n}\n.loading-content img{\n    width: 60px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/loading/loading.component.css
// module id = ./src/app/loading/loading.component.css
// module chunks = main